import { Card, CardContent, CardHeader, Grid, MenuItem, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import FormSelect from "../forms/form-select/FormSelect";
import FormRadioGroup, { FormRadioGroupRadioButton } from "../forms/form-radio-group/FormRadioGroup";
import { AccountSettingsV2FormType } from "./AccountSettingsV2Utils";
import { SampleGrid } from "../account-settings/account-preferences/SampleGrid";

const radioButtons: FormRadioGroupRadioButton[] = [{
    label: 'Light',
    ariaLabel: 'light theme',
    value: 'light'
}, {
    label: 'Dark',
    ariaLabel: 'dark theme',
    value: 'dark'
}];


export default function AppearanceCard() {

    const { t } = useTranslation();
    const theme = useTheme();
    const {
        watch,
        //getValues,
        //setValue
    } = useFormContext<AccountSettingsV2FormType>();

    const [gridCellPadding, gridFontSize] = watch([
        "gridCellPadding",
        "gridFontSize"
    ]);

    return (
        <Card
            raised={true}
            sx={{
                flex: "0 0 auto",
                margin: theme.spacing(1),
                padding: theme.spacing(2)
            }}
        >
            <CardHeader
                    sx={{
                        padding: 1
                    }}
                    //title={userState.user?.displayText}
                    title={t('profile.appearance')}
                    slotProps={{
                        title: {
                            sx: {
                                fontWeight: "bold", 
                            },
                            variant: 'h5', 
                            //marginLeft: 2 
                        }
                    }}
                />
            <CardContent
                sx={{
                    padding: 1,
                    paddingBottom: theme => `${theme.spacing(1)} !important`
                }}
            >

                <Grid container spacing={2}>

                    <Grid size={{ xs: 12 }}>

                        <Typography sx={{
                            fontWeight: 'bold'
                        }}>
                            {t('profile.theme')}
                        </Typography>
                        <FormRadioGroup label=''
                            name='theme'
                            radioButtons={radioButtons} 
                        />


                    </Grid>


                    {/* <Grid size={{ xs: 12}}>
                        <FormProperty>
                                            <FormCheckbox
                                                name="offlineMode"
                                                ariaLabel='offline mode enable'
                                                label={t('profile.offlineMode')}
                                                sx={{ width: '90%' }}
                                            />
                        
                                        </FormProperty>
                    </Grid> */}

                     <Grid size={{ xs: 12 }}>
                        <Typography sx={{
                            fontWeight: 'bold'
                        }}>
                            {t('profile.textAndTable')}
                        </Typography>


                        <FormSelect
                            id="gridFontSize"
                            name="gridFontSize"
                            label={t('profile.gridFontSize')}
                            sx={{ width: '90%' }}
                        >
                            {[...Array(9).keys()].map((o, ndx) =>
                                <MenuItem key={ndx} value={o+10}>
                                    {`${o+10} px`}
                                </MenuItem>
                            )}
                        </FormSelect>
                    </Grid>


                     <Grid size={{ xs: 12 }}>

                        <FormSelect
                            id="gridCellPadding"
                            name="gridCellPadding"
                            label={t('profile.gridCellPadding')}
                            sx={{ width: '90%' }}
                        >
                            {[...Array(9).keys()].map((o, ndx) =>
                                <MenuItem key={ndx} value={o}>
                                    {`${o} px`}
                                </MenuItem>
                            )}
                        </FormSelect>

                    </Grid>

                     <Grid size={{ xs: 12 }}>

                        <FormSelect
                            id="pagesize"
                            name="pageSize"
                            label={t('profile.gridPageSize')}
                            sx={{ width: '90%' }}

                        >
                            {[50, 100, 250].map((o, ndx) =>
                                <MenuItem key={ndx} value={o}>
                                    {`${o} Rows`}
                                </MenuItem>
                            )}
                        </FormSelect>

                    </Grid>
                    
                    <Grid size={{ xs: 12 }}>

                        <Typography variant='body2' sx={{
                            fontSize: '.85rem'
                        }}>
                            {t('profile.preview')}
                        </Typography>

                        <SampleGrid spacing={gridCellPadding} fontSize={gridFontSize} />

                    </Grid>
                </Grid>

           </CardContent>
        </Card>
    );
}